<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form"
                   v-model="form"
                   label-width="110px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="平台名称">
                  <el-input v-model="form.platName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="平台编号">
                  <el-input v-model="form.platCode"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="启用状态">
                  <el-select v-model="form.actFlag">
                    <el-option label="不限"
                               value></el-option>
                    <el-option label="启用"
                               value="T"></el-option>
                    <el-option label="禁用"
                               value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :span="6">
                  <el-button @click="dialogFormVisible = true">新增平台</el-button>
                  <el-button type="primary"
                             @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>

    <el-table :data="PlateList"
              v-loading="loading"
              :show-overflow-tooltip="true"
              border
              stripe
              style="width: 100%"
              height="500">
      <el-table-column type="index"
                       label="#"></el-table-column>
      <el-table-column prop="platName"
                       label="平台名称"></el-table-column>
      <el-table-column prop="platCode"
                       label="平台编号"
                       min-width="120px"></el-table-column>
      <el-table-column prop="apiUrl"
                       label="接口地址"
                       show-overflow-tooltip
                       min-width="120px"></el-table-column>
      <el-table-column prop="sandbox"
                       label="测试地址"
                       show-overflow-tooltip
                       min-width="120px"></el-table-column>
      <el-table-column prop="appKey"
                       label="appKey"
                       show-overflow-tooltip
                       min-width="120px"></el-table-column>
      <el-table-column prop="appSecret"
                       label="appSecret"
                       show-overflow-tooltip
                       min-width="120px"></el-table-column>
      <el-table-column prop="actFlag"
                       label="激活状态"
                       min-width="80px">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.actFlag"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-value="T"
                     inactive-value="F"
                     @change="chageAct(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       min-width="120px">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark"
                      content="编辑"
                      placement="top"
                      :enterable="false">
            <el-button type="primary"
                       icon="el-icon-edit"
                       size="mini"
                       @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip effect="dark"
                      content="删除"
                      placement="top"
                      :enterable="false">
            <el-button type="danger"
                       icon="el-icon-delete"
                       size="mini"
                       @click="delPlate(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="queryInfo.pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
    </div>

    <el-dialog title="新增平台"
               :visible.sync="dialogFormVisible"
               width="600px"
               @close="addDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="addform"
               ref="addformRef"
               :rule="rules"
               :rules="rules">
        <el-form-item label="平台名称"
                      prop="platName"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.platName"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="平台编号"
                      prop="platCode"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.platCode"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="接口地址"
                      prop="apiUrl"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.apiUrl"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="沙箱地址"
                      prop="sandbox"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.sandbox"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="appKey"
                      prop="appKey"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.appKey"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="appSecret"
                      prop="appSecret"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.appSecret"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注"
                      :label-width="formLabelWidth">
          <el-input v-model="addform.memo"
                    autocomplete="on"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    style="width:100%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addPlate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑平台"
               :visible.sync="editdialogFormVisible"
               width="600px"
               @close="editDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="editform"
               ref="editformRef"
               :rule="rules"
               :rules="rules">
        <el-form-item label="平台名称"
                      prop="platName"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.platName"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="平台编号"
                      prop="platCode"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.platCode"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="接口地址"
                      prop="apiUrl"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.apiUrl"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="沙箱地址"
                      prop="sandbox"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.sandbox"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="appKey"
                      prop="appKey"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.appKey"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="appSecret"
                      prop="appSecret"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.appSecret"
                    autocomplete="on"
                    style="width:100%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态"
                      prop="actFlag"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.memo"
                    autocomplete="on"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    style="width:100%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="savePlate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/
      if (regEmail.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的邮箱'))
    }
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      // 符合规则
      if (regMobile.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }

    return {
      form: {
        platName: '',
        platCode: '',
        actFlag: '',
      },
      addform: {
        platName: '',
        platCode: '',
        apiUrl: '',
        sandbox: '',
        appKey: '',
        appSecret: '',
        actFlag: '',
        memo: '',
      },
      editform: {
        platName: '',
        platCode: '',
        apiUrl: '',
        sandbox: '',
        appKey: '',
        appSecret: '',
        actFlag: '',
        memo: '',
      },
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      selvalue: '',
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: '90px',
      rules: {
        platName: [
          { required: true, message: '请输入平台名称', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        platCode: [
          { required: true, message: '请输入平台编号', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        apiUrl: [{ type: 'url', message: 'api地址不合法', trigger: 'blur' }],
        sandbox: [{ type: 'url', message: '沙箱地址不合法', trigger: 'blur' }],
        appKey: [
          {
            min: 2,
            max: 64,
            message: '长度在 2 到 32 个字符',
            trigger: 'blur',
          },
        ],
        appSecret: [
          {
            min: 2,
            max: 64,
            message: '长度在 2 到 64 个字符',
            trigger: 'blur',
          },
        ],
      },
      PlateList: [],
      errmsg: '',
      loading: true,
    }
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getPlateLists()
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val

      this.getPlateLists()
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val

      this.getPlateLists()
    },

    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields()
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields()
    },
    // 新增平台
    async addPlate() {
      // this.$refs.addformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post('addplat', this.addform)
        .then((response) => {
          this.$message.success('添加平台成功')
          this.dialogFormVisible = false
          this.getPlateLists()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 显示修改用户对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row)
      this.editform = copy
      this.editdialogFormVisible = true
    },
    // 保存编辑平台信息
    savePlate() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post('editplat', this.editform)
        .then((response) => {
          this.$message.success('编辑仓库成功')
          this.editdialogFormVisible = false
          this.getPlateLists()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 删除平台
    async delPlate(platid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除该平台, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)

      // 确认删除
      if (confirmResult == 'confirm') {
        await this.$http
          .delete('delplat/' + platid)
          .then((response) => {
            this.$message.success('删除成功')

            this.getPlateLists()
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
      }
    },
    // 变更激活状态
    async chageAct(PlateInfo) {
      await this.$http
        .put('actplat/' + PlateInfo.id + '/' + PlateInfo.actFlag)
        .then((response) => {
          const res = response.data
          this.$message.success(res.data)
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 获取平台列表
    async getPlateLists() {
      this.loading = true
      await this.$http
        .post('platlists', this.queryInfo)
        .then((response) => {
          const res = response.data
          this.PlateList = res.data.data

          this.total = res.data.total

          this.loading = false
          this.currentPage = res.data.current_page
        })
        .catch((error) => {
          this.loading = false
          return this.$message.error(error.response.data.message)
        })
    },
  },
  created() {
    this.getPlateLists()
  },
}
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/plate/index.vue